import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import api from '@/api'
import store from '@/store'
import { mapGetters } from 'vuex'
// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar)
Vue.use(VeeValidate)
locale.use(lang)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!api.auth.user()) {
      next({
        path: '/login'
        // query: {
        //   redirect: to.fullPath
        // }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

const unsubscribe = api.auth.changed((user) => {
  /* eslint-disable no-new */
  new Vue({
    router,
    store,
    el: '#app',
    render: h => h(App),
    created () {
      api.auth.changed((user) => {
        store.dispatch('profiles/bind', user)
      })
    },
    watch: {
      profile (profile) {
        store.dispatch('companies/bind', profile)
      }
    },
    computed: {
      ...mapGetters('profiles', {
        profile: 'mine'
      })
    }
  })
  unsubscribe()
})



// WEBPACK FOOTER //
// ./src/main.js